// extracted by mini-css-extract-plugin
module.exports = {"iconButtonWithBadge":"IconButtonWithBadge_iconButtonWithBadge__WaKG7","badge":"IconButtonWithBadge_badge__n8SBW"};